import { render, staticRenderFns } from "./WhiteListFactCard.vue?vue&type=template&id=003ae718"
import script from "./WhiteListFactCard.vue?vue&type=script&lang=js"
export * from "./WhiteListFactCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports